export const ALREADY_UPDATED = 'already_updated';
export const EXPIRED = 'expired';
export const FAILED_TO_LOAD = 'failed_to_load';
export const EXPIRED_REGISTRATION = 'expired_registration';
